import locale7742768a from '../../lang/en-IE'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: true,
}
export const options = {
  vueI18n: {"fallbackLocale":"en","numberFormats":{"en":{"currency":{"style":"currency","currency":"EUR"},"currencyRound":{"style":"currency","currency":"EUR","minimumFractionDigits":0,"maximumFractionDigits":0},"percent":{"style":"percent","maximumFractionDigits":2},"percentAPR":{"style":"percent","minimumFractionDigits":2,"maximumFractionDigits":2},"toWholeNumber":{"style":"decimal","minimumFractionDigits":0,"maximumFractionDigits":0}}},"silentTranslationWarn":true},
  vueI18nLoader: true,
  locales: [{"code":"en","file":"en-IE","name":"English","iso":"en-IE"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "lang/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true,"alwaysReload":true},
  differentDomains: false,
  baseUrl: "https://www.bonkers.ie",
  vuex: {"moduleName":"i18n","syncRouteParams":true,"syncLocale":true,"syncMessages":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en","file":"en-IE","name":"English","iso":"en-IE"}],
  localeCodes: ["en"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: "-",
  5: "I",
  6: "E",
  7: "\"",
  8: ":",
  9: "\"",
  10: ".",
  11: ".",
  12: "/",
  13: "l",
  14: "a",
  15: "n",
  16: "g",
  17: "/",
  18: "e",
  19: "n",
  20: "-",
  21: "I",
  22: "E",
  23: "\"",
  24: "}",
}

export const localeMessages = {
  'en-IE': () => Promise.resolve(locale7742768a),
}
